import React from 'react'
import SEO from '../common/SEO'
import ColorSwitcher from '../elements/switcher/ColorSwitcher'
import seoData from '../seoData/SocialMediaMarketing.json'
import CtaLayoutOne from '../component/cta/CtaLayoutOne'
import FooterOne from '../common/footer/FooterOne'
import HeaderOne from '../common/header/HeaderOne'
import BannerSocialMediaMarketing from '../component/banner/BannerSocialMediaMarketing'
import SectionTitle from '../elements/section-title/SectionTitle'
import ServicePropThree from '../component/service/ServicePropThree'
import SMMServicesData from "../data/smm/SMMServices.json"
import BestForYouSection from '../component/features/BestForYouSection'
import GrowthPrioritySection from '../component/features/GrowthPrioritySection'
import TestimonialPropTwo from '../component/testimonial/TestimonialPropTwo'
import TestimonialData from '../data/testimonial/TestimonialData.json'
import { slugify } from '../utils'

const allData = TestimonialData;

const SocialMediaMarketing = () => {
    const facebookData = allData.filter(
        (data) => slugify(data.fromtext) === "facebook"
    );

    return (
        <>
            <SEO {...seoData} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />

                {/* Hero Banner Section */}
                <div className="section section-padding pb-0 ">
                    <BannerSocialMediaMarketing />
                </div>

                {/* Best For You Section */}
                <BestForYouSection />

                {/* Services Section */}
                <div className="section section-padding bg-color-white" style={{
                    background: "linear-gradient(to bottom, #F2F2FF, #FFFFFF)"
                }}>
                    <div className="container">
                        <SectionTitle
                            subtitle="What We Can Do For You"
                            title="Services we can help you <br className='d-none d-lg-block' /> with"
                            textAlignment="title heading-left mb--40"
                            textColor=""
                        />
                        <ul className="list-unstyled shape-group-10">
                            <li className="shape shape-1">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/others/line-9.png"}
                                    alt="Circle"
                                    style={{
                                        opacity: "0.2",
                                        maxWidth: "80%",
                                        float: "inline-end"
                                    }}
                                />
                            </li>
                        </ul>
                        <div className="service-smm-container">
                            <div className="row">
                                <ServicePropThree
                                    colSize="col-lg-4 col-md-12"
                                    serviceStyle="service-style-3"
                                    serviceData={SMMServicesData}
                                />
                            </div>
                            <img src={process.env.PUBLIC_URL + "/images/icon/smm-hand.png"} alt="smm hand icon" className='smm-hand' />
                        </div>
                    </div>
                </div>

                {/* Your Growth Our Priority Section */}
                <GrowthPrioritySection />

                {/* Testimonials Section */}
                <div className="section section-padding customer-review-area overflow-hidden pb-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <SectionTitle
                                    subtitle=""
                                    title="Testimonials"
                                    textAlignment="heading-left"
                                    textColor=""
                                />
                            </div>
                            <div className="col-lg-4">
                                <div className="review-site-logo"></div>
                            </div>
                        </div>
                        <div className="row">
                            <TestimonialPropTwo
                                colSize="col-lg-3"
                                itemShow="5"
                                layoutStyle="testimonial-dark"
                                testimonialData={facebookData}
                            />
                        </div>
                    </div>
                    <ul className="shape-group-11 list-unstyled">
                        <li className="shape shape-1">
                            <img
                                src={process.env.PUBLIC_URL + "/images/others/line-6.png"}
                                alt="line"
                            />
                        </li>
                        <li className="shape shape-2">
                            <img
                                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                                alt="line"
                            />
                        </li>
                    </ul>
                </div>

                {/* Read Reviews Section */}
                {/* CTA and Footer */}
                <CtaLayoutOne />
                <FooterOne parentClass="" />
            </main >
        </>
    )
}

export default SocialMediaMarketing